import MainVisual from './MainVisual';
export default MainVisual;
